import { create } from 'zustand';
import { generalSettingsDefault } from '../../modules/general-settings/GeneralSettingsPage';

import { ordersRepository } from '../../modules/orders/repositories/ordersRepository/orders.repository';
import { GeneralSettingsParams, GeneralSettingsStore } from './generalSettings.types';

const channel = new BroadcastChannel('general-settings');

const useGeneralSettingsStore = create<GeneralSettingsStore>((set) => ({
  generalSettings: {
    ...generalSettingsDefault,
  },
  fetchGeneralSettings: async () => {
    const repository = ordersRepository();

    const response = await repository.getBrandSettings();

    if (response.ok) {
      const generalSettings = response?.data;
      set({ generalSettings });
    }
  },
  updateGeneralSettings: (generalSettings: GeneralSettingsParams) => {
    set({ generalSettings });
    channel.postMessage(generalSettings);
  },
  clearGeneralSettings: () => set({ generalSettings: { ...generalSettingsDefault } }),
}));

channel.onmessage = ({ data }: MessageEvent<GeneralSettingsParams>) => {
  useGeneralSettingsStore.setState({ generalSettings: data });
};

export default useGeneralSettingsStore;
